import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=5add4f18&scoped=true&"
import script from "./PlaceOrder.vue?vue&type=script&lang=ts&"
export * from "./PlaceOrder.vue?vue&type=script&lang=ts&"
import style0 from "./PlaceOrder.vue?vue&type=style&index=0&id=5add4f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add4f18",
  null
  
)

export default component.exports